import { Divider, Grid } from "@mui/material";
import React from "react";
import { formatDate, useFormatPrice } from "hooks";

const ReturnAmount = ({ value }) => {
  const formatPrice = useFormatPrice();

  const renderPriceRow = (label, amount, className) => (
    <div className={`flex justify-between items-center ${className}`}>
      <span>{label}</span>
      <span>{formatPrice(amount)}</span>
    </div>
  );

  return value && value.id ? (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5} order={{ xs: 2, md: 1 }}>
          <div className="flex flex-col gap-1 text-gray-500">
            <div className="flex gap-3">
              <div className="flex flex-col">
                <span className="text-[11px] uppercase">Refund Cashier </span>
                <span className="font-medium">
                  {value.user && value.user?.fullName}
                </span>
              </div>
              <div className="flex flex-col pl-2 border-l">
                <span className="font-medium text-[14px]">
                  Return Invoice Id: {value.id}
                </span>
                <span className="text-[12px]">
                  Date: {formatDate(value.returnDate)}
                </span>
              </div>
            </div>
            <Divider />
            <div className="flex flex-col">
              <span className="font-medium text-[14px]">
                Total Return Items: {formatPrice(value.totalReturnItem)}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-[12px]">
                  Sellable Items: {formatPrice(value.totalSellable)}
                </span>
                |
                <span className="text-[12px]">
                  Unsellable Items: {formatPrice(value.totalUnsellable)}
                </span>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} md={7} order={{ xs: 1, md: 2 }}>
          <div className="flex flex-col gap-1 text-gray-500">
            {renderPriceRow("Discount Adjustment (-)", value.discAdj)}
            <Divider />
            {renderPriceRow(`Total Return Tax	 (+)`, value.refundTaxAmt)}
            <Divider />
            {renderPriceRow(
              "Return Total",
              value.refundAmt,
              "uppercase font-bold text-red-500"
            )}
          </div>
        </Grid>
      </Grid>
    </>
  ) : (
    "Data not found"
  );
};

export default ReturnAmount;
